import { BasePage } from '@/components/ui/base-page'

export function CommoditiesContractsPage() {
  return (
    <BasePage
      title="Commodities Contracts"
      description="Commodity investment vehicles"
    >
      {/* Add CommoditiesContractsPage specific content here */}
    </BasePage>
  )
}